import { useMutation } from 'react-query'
import { postAPI } from 'framework/api/http'

interface CreateOrderOnHoldInterface {
  partnerOrderId?: string
  reason?: string
  actualReason?: string
  date?: any
}
export const useCreateOrderOnHold = () => {
  const mutate = useMutation(
    ({
      partnerOrderId,
      reason,
      actualReason,
      date,
    }: CreateOrderOnHoldInterface) => {
      return postAPI(`/OrderOnHold`, {
        partnerOrderId,
        holdReason: reason,
        holdActualReason: actualReason,
        dateTobeReleased: date,
      })
    },
  )
  return mutate
}
export default useCreateOrderOnHold
